import { createContext, type ReactNode, useContext } from 'react';
import type { HobbyToolsClient } from './client';

const SupabaseContext = createContext<HobbyToolsClient | null>(null);

export function SupabaseProvider({ client, children }: { client: HobbyToolsClient; children: ReactNode }) {
  return <SupabaseContext.Provider value={client}>{children}</SupabaseContext.Provider>;
}

export function useSupabase(): HobbyToolsClient {
  const client = useContext(SupabaseContext);
  if (!client) throw new Error('useSupabase must be used inside <SupabaseProvider>');
  return client;
}
